<template>
  <div class="loader-container">
    <Transition name="fadeIn">
      <div
        v-if="loading"
        class="ui inverted dimmer active"
      >
        <div class="ui text loader">
          Récupération des signalements en cours...
        </div>
      </div>
    </Transition>

    <div
      data-tab="list"
      class="dataTables_wrapper no-footer"
    >
      <table
        id="table-features"
        class="ui compact table unstackable dataTable"
        aria-describedby="Liste des signalements du projet"
      >
        <thead>
          <tr>
            <th
              v-if="isOnline"
              scope="col"
              class="dt-center"
            >
              <div
                class="ui checkbox"
                :data-tooltip="isAllSelected ? 'Tout désélectionner' : 'Tout sélectionner'"
                data-position="left center"
              >
                <input
                  id="select-all"
                  v-model="isAllSelected"
                  type="checkbox"
                  name="select-all"
                >
                <label for="select-all" /> 
              </div>
            </th>

            <th
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('status')"
              >
                Statut
                <i
                  :class="{
                    down: isSortedAsc('status'),
                    up: isSortedDesc('status'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('feature_type')"
              >
                Type
                <i
                  :class="{
                    down: isSortedAsc('feature_type'),
                    up: isSortedDesc('feature_type'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('title')"
              >
                Nom
                <i
                  :class="{
                    down: isSortedAsc('title'),
                    up: isSortedDesc('title'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('created_on')"
              >
                Date de création
                <i
                  :class="{
                    down: isSortedAsc('created_on'),
                    up: isSortedDesc('created_on'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('updated_on')"
              >
                Dernière modification
                <i
                  :class="{
                    down: isSortedAsc('updated_on'),
                    up: isSortedDesc('updated_on'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              v-if="user"
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('display_creator')"
              >
                Auteur
                <i
                  :class="{
                    down: isSortedAsc('display_creator'),
                    up: isSortedDesc('display_creator'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
            <th
              v-if="user"
              scope="col"
              class="dt-center"
            >
              <div
                :class="isOnline ? 'pointer' : 'disabled'"
                @click="changeSort('display_last_editor')"
              >
                Dernier éditeur
                <i
                  :class="{
                    down: isSortedAsc('display_last_editor'),
                    up: isSortedDesc('display_last_editor'),
                  }"
                  class="icon sort"
                  aria-hidden="true"
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(feature, index) in paginatedFeatures"
            :key="index"
          >
            <td
              v-if="isOnline"
              id="select"
              class="dt-center"
            >
              <div class="ui checkbox">
                <input
                  :id="feature.feature_id"
                  type="checkbox"
                  :value="feature.feature_id"
                  :checked="isFeatureSelected(feature)"
                  name="select"
                  @input="handleFeatureSelection($event, feature)"
                >
                <label :for="feature.feature_id" />
              </div>
            </td>

            <td
              id="status"
              class="dt-center"
            >
              <div
                :data-tooltip="statusLabel(feature.status)"
              >
                <i
                  :class="[statusIcon(feature.status), 'icon']"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td
              id="type"
              class="dt-center"
            >
              <router-link
                :to="{
                  name: 'details-type-signalement',
                  params: {
                    feature_type_slug: feature.feature_type.slug,
                  },
                }"
                class="ellipsis space-left"
              >
                {{ feature.feature_type.title }}
              </router-link>
            </td>
            <td
              id="name"
              class="dt-center"
            >
              <router-link
                :to="{
                  name: 'details-signalement-filtre',
                  query: { ...queryparams, offset: queryparams.offset + index }
                }"
                class="ellipsis space-left"
              >
                {{ feature.title || feature.feature_id }}
              </router-link>
            </td>
            <td
              id="create"
              class="dt-center"
            >
              {{ feature.created_on | formatDate }}
            </td>
            <td
              id="update"
              class="dt-center"
            >
              {{ feature.updated_on | formatDate }}
            </td>
            <td
              v-if="user"
              id="author"
              class="dt-center"
            >
              {{ feature.display_creator || ' ---- ' }}
            </td>
            <td
              v-if="user"
              id="last_editor"
              class="dt-center"
            >
              {{ feature.display_last_editor || ' ---- ' }}
            </td>
          </tr>
          <tr
            v-if="featuresCount === 0"
            class="odd"
          >
            <td
              colspan="5"
              class="dataTables_empty"
              valign="top"
            >
              Aucune donnée disponible
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="pageNumbers.length > 1"
        id="table-features_info"
        class="dataTables_info"
        role="status"
        aria-live="polite"
      >
        Affichage de l'élément {{ pagination.start + 1 }} à
        {{ displayedPageEnd }}
        sur {{ featuresCount }} éléments
      </div>
      <div
        v-if="pageNumbers.length > 1 && isOnline"
        id="table-features_paginate"
        class="dataTables_paginate paging_simple_numbers"
      >
        <a
          id="table-features_previous"
          :class="[
            'paginate_button previous',
            { disabled: pagination.currentPage === 1 },
          ]"
          aria-controls="table-features"
          data-dt-idx="0"
          tabindex="0"
          @click="$emit('update:page', 'previous')"
        >Précédent</a>
        <span>
          <span v-if="pagination.currentPage > 5">
            <a
              key="page1"
              class="paginate_button"
              aria-controls="table-features"
              data-dt-idx="1"
              tabindex="0"
              @click="$emit('update:page', 1)"
            >1</a>
            <span class="ellipsis">…</span>
          </span>
          <a
            v-for="pageNumber in displayedPageNumbers"
            :key="'page' + pageNumber"
            :class="[
              'paginate_button',
              { current: pageNumber === pagination.currentPage },
            ]"
            aria-controls="table-features"
            data-dt-idx="1"
            tabindex="0"
            @click="$emit('update:page', pageNumber)"
          >{{ pageNumber }}</a>
          <span v-if="(lastPageNumber - pagination.currentPage) > 4">
            <span class="ellipsis">…</span>
            <a
              :key="'page' + lastPageNumber"
              class="paginate_button"
              aria-controls="table-features"
              data-dt-idx="1"
              tabindex="0"
              @click="$emit('update:page', lastPageNumber)"
            >{{ lastPageNumber }}</a>
          </span>
        </span>
        <a
          id="table-features_next"
          :class="[
            'paginate_button next',
            { disabled: pagination.currentPage === pageNumbers.length },
          ]"
          aria-controls="table-features"
          data-dt-idx="7"
          tabindex="0"
          @click="$emit('update:page', 'next')"
        >Suivant</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { formatStringDate, statusChoices, getStatusIconClass } from '@/utils';

export default {
  name: 'FeatureListTable',

  filters: {
    formatDate(value) {
      return formatStringDate(value);
    },
  },
  
  props: {
    paginatedFeatures: {
      type: Array,
      default: null,
    },
    pageNumbers: {
      type: Array,
      default: null,
    },
    featuresCount: {
      type: Number,
      default: 0,
    },
    pagination: {
      type: Object,
      default: null,
    },
    sort: {
      type: Object,
      default: null,
    },
    queryparams: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapGetters('feature', [  
      'checkedFeaturesSet',
      'uncheckedFeaturesSet',
      'totalFeaturesCount',
    ]),
    ...mapState([
      'user',
      'USER_LEVEL_PROJECTS',
      'isOnline'
    ]),
    ...mapState('projects', ['project']),
    ...mapState('feature', [
      'allSelected',
      'checkedFeatures',
      'uncheckedFeatures',
    ]),

    isAllSelected: {
      get() {
        return this.allSelected;
      },
      set(checked) {
        this.SET_ALL_SELECTED(checked);
        this.SET_UNCHECKED_FEATURES([]);
        this.SET_CHECKED_FEATURES([]);
      },
    },

    displayedPageEnd() {
      return this.featuresCount <= this.pagination.end
        ? this.featuresCount
        : this.pagination.end;
    },

    lastPageNumber() {
      return this.pageNumbers.slice(-1)[0];
    },

    displayedPageNumbers() {
      //* s'il y a moins de 5 pages, renvoyer toutes les pages
      if (this.lastPageNumber < 5) {
        return this.pageNumbers;
      }
      //* si la page courante est inférieur à 5, la liste commence à l'index 0 et on retourne 5 pages
      let firstPageInList = 0;
      let pagesQuantity = 5;
      //* à partir de la 5ième page et jusqu'à la 4ième page avant la fin : n'afficher que 3 page entre les ellipses et la page courante doit être au milieu
      if (this.pagination.currentPage >= 5 && !((this.lastPageNumber - this.pagination.currentPage) < 4)) {
        firstPageInList = this.pagination.currentPage - 2;
        pagesQuantity = 3;
      }
      //* à partir de 4 résultat avant la fin afficher seulement les 5 derniers résultats
      if ((this.lastPageNumber - this.pagination.currentPage) < 4) {
        firstPageInList = this.lastPageNumber - 5;
      }
      return this.pageNumbers.slice(firstPageInList, firstPageInList + pagesQuantity);
    },
  },

  mounted() {
    // Reinitialize user selection for when turning back from edit attributes page
    this.SET_CHECKED_FEATURES([]);
    this.SET_UNCHECKED_FEATURES([]);
    this.SET_ALL_SELECTED(false);
  },

  methods: {
    ...mapMutations('feature', [
      'SET_ALL_SELECTED',
      'SET_CHECKED_FEATURES',
      'SET_UNCHECKED_FEATURES',
    ]),

    statusIcon(statusName) {
      return getStatusIconClass(statusName);
    },
    statusLabel(statusName) {
      return statusChoices[statusName];
    },

    /**
     * Checks if a feature should be selected based on the global selection state.
     * @param {Object} feature - The feature object.
     * @returns {Boolean} - `true` if the feature should be checked.
     */
    isFeatureSelected(feature) {
      if (this.isAllSelected) {
        return !this.uncheckedFeaturesSet.has(feature.feature_id);
      } else {
        return this.checkedFeaturesSet.has(feature.feature_id);
      }
    },

    /**
     * Adds or removes a feature from the selection based on the checkbox state.
     * @param {Event} event - The checkbox change event.
     * @param {Object} feature - The associated feature.
     */
    handleFeatureSelection(event, feature) {
      const isChecked = event.target.checked;
      if (this.isAllSelected) {
        // If "all are selected", manage exceptions via uncheckedFeatures
        const updatedUncheckedFeatures = isChecked
          ? this.uncheckedFeatures.filter(el => el.feat_id !== feature.feature_id) // Remove from excluded list
          : [...this.uncheckedFeatures, { feat_id: feature.feature_id, ft_slug: feature.feature_type.slug }]; // Add to excluded list
        this.SET_UNCHECKED_FEATURES(updatedUncheckedFeatures);
        // Check if all checkboxes are unchecked (everything is excluded)
        if (updatedUncheckedFeatures.length === this.totalFeaturesCount) {
          this.SET_ALL_SELECTED(false);
          this.SET_UNCHECKED_FEATURES([]);
        }
      } else {
        // Classic behavior: update checkedFeatures
        const updatedFeatures = isChecked
          ? [...this.checkedFeatures, { feat_id: feature.feature_id, ft_slug: feature.feature_type.slug }]
          : this.checkedFeatures.filter(el => el.feat_id !== feature.feature_id);
        this.SET_CHECKED_FEATURES(updatedFeatures);
        // Check if all checkboxes are checked
        if (updatedFeatures.length === this.totalFeaturesCount) {
          this.SET_ALL_SELECTED(true);
          this.SET_CHECKED_FEATURES([]);
        }
      }
    },

    isSortedAsc(column) {
      return this.sort.column === column && this.sort.ascending;
    },
    isSortedDesc(column) {
      return this.sort.column === column && !this.sort.ascending;
    },

    changeSort(column) {
      if (!this.isOnline) return;
      if (this.sort.column === column) {
        //changer only order
        this.$emit('update:sort', {
          column: this.sort.column,
          ascending: !this.sort.ascending,
        });
      } else { // change column and reset order
        this.$emit('update:sort', { column, ascending: true });
      }
    },
  },
};
</script>

<style scoped>
.loader-container {
  position: relative;
  min-height: 250px;/* keep a the spinner above result and below table header */
}
.ui.inverted.dimmer.active {
  opacity: .6;
}

.fadeIn-enter-active {
  animation: fadeIn .5s;
}
.fadeIn-leave-active {
  animation: fadeIn .5s reverse;
}
.transition.fade.in {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0
  }

  100% {
    opacity: .9
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0
  }

  100% {
    opacity: .9
  }
}

/* datatables */
.dataTables_wrapper {
  position: relative;
  clear: both;
}
.dataTables_paginate {
  margin-bottom: 1rem;
}
table.dataTable th.dt-center, table.dataTable td.dt-center, table.dataTable td.dataTables_empty {
  text-align: center;
}
.dataTables_wrapper .dataTables_length,
.dataTables_wrapper .dataTables_filter,
.dataTables_wrapper .dataTables_info,
.dataTables_wrapper .dataTables_processing,
.dataTables_wrapper .dataTables_paginate {
  color: #333;
}
.dataTables_wrapper .dataTables_info {
  clear: both;
  float: left;
  padding-top: 0.755em;
}
.dataTables_wrapper .dataTables_paginate {
  float: right;
  text-align: right;
  padding-top: 0.25em;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  color: #333 !important;
  border: 1px solid #979797;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #fff),
    color-stop(100%, #dcdcdc)
  );
  background: -webkit-linear-gradient(top, #fff 0%, #dcdcdc 100%);
  background: -moz-linear-gradient(top, #fff 0%, #dcdcdc 100%);
  background: -ms-linear-gradient(top, #fff 0%, #dcdcdc 100%);
  background: -o-linear-gradient(top, #fff 0%, #dcdcdc 100%);
  background: linear-gradient(to bottom, #fff 0%, #dcdcdc 100%);
}
.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  padding: 0.5em 1em;
  margin-left: 2px;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  border: 1px solid transparent;
  border-radius: 2px;
}
.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: white !important;
  border: 1px solid #111;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #585858),
    color-stop(100%, #111)
  );
  background: -webkit-linear-gradient(top, #585858 0%, #111 100%);
  background: -moz-linear-gradient(top, #585858 0%, #111 100%);
  background: -ms-linear-gradient(top, #585858 0%, #111 100%);
  background: -o-linear-gradient(top, #585858 0%, #111 100%);
  background: linear-gradient(to bottom, #585858 0%, #111 100%);
}
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {
  cursor: default;
  color: #666 !important;
  border: 1px solid transparent;
  background: transparent;
  box-shadow: none;
}

.dataTables_wrapper .dataTables_paginate .ellipsis {
  padding: 0 1em;
}

i.icon.sort:not(.down):not(.up) {
  color: rgb(220, 220, 220);
}

.grey {
  color: #bbbbbb;
}

.table-mobile-buttons {
  margin-bottom: 1em;
}

/* increase contrast between available checkboxes and disabled ones */
#table-features .ui.disabled.checkbox label::before {
  background-color: #fbf5f5;;  
}

#select-all + label {
  text-align: left;
  &:hover {
    cursor: pointer;
  }
}

@media only screen and (min-width: 761px) {
  .table-mobile-buttons {
    display: none !important;
  }
}
/*
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
@media only screen and (max-width: 760px) {
  .table-mobile-buttons {
    display: flex !important;
    }
  .inline.fields label {
    width: 100% !important;
  }
  /* hide table border */
  .ui.table {
    border: none !important;
    margin-top: 2em;
  }
  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr { /* style as a card */
    border: 1px solid #ccc;
    border-radius: 7px;
    margin-bottom: 3vh;
    padding: 0 2vw .5em 2vw;
    box-shadow: rgba(50, 50, 50, 0.1) 2px 5px 10px ;
  }

  td {
    /* Behave like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  .ui.table tr td {
    border-top: none;
  }
  .ui.compact.table td {
    padding: .2em;
  }
  td:nth-of-type(1) {
    border: none !important;
    padding: .25em !important;
  }
  td:nth-of-type(8) {
    border-bottom: none !important;
  }
  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }
  /*
	Label the data
	*/
  td#select:before {
    content: "";
  }
  td#status:before {
    content: "Statut";
  }
  td#type:before {
    content: "Type";
  }
  td#name:before {
    content: "Nom";
  }
  td#create:before {
    content: "Date de création";
  }
  td#update:before {
    content: "Dernière modification";
  }
  td#author:before {
    content: "Auteur";
  }
  td#last_editor:before {
    content: "Dernier éditeur";
  }

  table.dataTable th.dt-center, table.dataTable td.dt-center, table.dataTable {
    text-align: right;
  }

  #select .ui.checkbox {
    position: absolute;
    left: calc(-1vw - 20px);
    top: -12px;
    min-height: 24px;
    font-size: 1rem;
    line-height: 24px;
    min-width: 24px;
  }
  #select .ui.checkbox .box::before, #select .ui.checkbox label::before,
  #select .ui.checkbox .box::after, #select .ui.checkbox label::after {
    width: 24px;
    height: 24px;
  }
  /* cover all the card to ease selection by user */
  #select .ui.checkbox {
    width: 100%;
  }
  #select .ui.checkbox input[type="checkbox"] {
    width: calc(100% + 1vw + 20px + 4vw);
    height: calc(14em + 12px);
  }
  /* keep the links above the checkbox input to receive the click event */
  table a {
    z-index: 4;
    position: sticky;
  }
  #select .ui.checkbox .box::before, #select .ui.checkbox label::before {
    border-radius: 12px;
  }
  #select .ui.checkbox .box::after, #select .ui.checkbox label::after {
    font-size: 18px;
  }
  .dataTables_wrapper .dataTables_info,
  .dataTables_wrapper .dataTables_paginate {
    width: 100%;
    text-align: center;
    margin: .5em 0;
  }
  /* preserve space to not overlap column label */
  .space-left {
    margin-left: 2.5em;
  }
}
@media only screen and (max-width: 410px) {
  .ui.table tr td {
    border: none;
  }
}
</style>
